import { AutogenModelAccountingCtrl, AutogenRowAccountingCtrl } from "./autogen/AutogenModelAccountingCtrl";

export class ModelAccountingCtrl extends AutogenModelAccountingCtrl<RowAccountingCtrl> {
	constructor() {
		super(RowAccountingCtrl);
	}
}

export class RowAccountingCtrl extends AutogenRowAccountingCtrl {
}